import type { PropType } from 'vue'

const predefinedThemes = ['consumer', 'pro'] as const

type Themes = typeof predefinedThemes[number]

export type ThemeProps = {
  theme?: Themes
}

export const useThemeProps = () => ({
  theme: {
    type: String as PropType<'consumer' | 'pro'>,
    default: 'consumer',
  },
})

export function useThemes() {
  const { $vuetify } = useNuxtApp()
  const isProTheme = useDark({
    valueDark: 'pro',
    valueLight: 'consumer',
    writeDefaults: true,
    onChanged(dark) {
      $vuetify.theme.change(dark ? 'pro' : 'consumer')
    },
  })

  function useProTheme() {
    isProTheme.value = true
  }

  function useConsumerTheme() {
    isProTheme.value = false
  }

  const isPro = computed(() => ['pro', 'dark'].includes($vuetify.theme.global.name.value))
  const isConsumer = computed(() => ['consumer', 'light'].includes($vuetify.theme.global.name.value))

  return {
    useProTheme,
    useConsumerTheme,
    isPro,
    isConsumer,
  }
}
